const DB_NAME = 'freezone_media_db';
const STORE_NAME = 'media_store';

function getDB() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, 1);
    request.onupgradeneeded = (e) => {
      const db = e.target.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    };
    request.onsuccess = (e) => resolve(e.target.result);
    request.onerror = (e) => reject(e.target.error);
  });
}

export const idbStorage = {
  async saveMedia(blob, prefix = 'media') {
    const db = await getDB();
    const id = `${prefix}_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;
    
    return new Promise((resolve, reject) => {
      const tx = db.transaction(STORE_NAME, 'readwrite');
      const store = tx.objectStore(STORE_NAME);
      const req = store.put(blob, id);
      
      req.onsuccess = () => resolve(`idb://${id}`);
      req.onerror = () => reject(req.error);
    });
  },

  async getMedia(idbUrl) {
    if (!idbUrl || !idbUrl.startsWith('idb://')) return null;
    const id = idbUrl.replace('idb://', '');
    
    const db = await getDB();
    return new Promise((resolve, reject) => {
      const tx = db.transaction(STORE_NAME, 'readonly');
      const store = tx.objectStore(STORE_NAME);
      const req = store.get(id);
      
      req.onsuccess = () => resolve(req.result || null);
      req.onerror = () => reject(req.error);
    });
  }
};
